import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import { DatetimeCustomEvent } from "@ionic/core";
import { Store } from "@ngxs/store";
import { AppState } from "src/store/app/app.state";

@Component({
    selector: "calendar",
    templateUrl: "./calendar.component.html",
    styleUrls: ["./calendar.component.scss"],
    standalone: false,
})
export class CalendarComponent implements OnInit {
    @Output() change: EventEmitter<any> = new EventEmitter();

    public datetime!: string | string[];
    public highlightedDates = [];
    public locale: string = "da-DK";
    private firstDateSelected: boolean = false;
    private lastStage: string[];

    constructor(private store: Store) {}

    ngOnInit(): void {
        this.setLocale();
    }

    /**
     * Handles the ionChange event from the calendar component.
     *
     * @param event
     */
    public onIonChange(event: DatetimeCustomEvent): void {
        if (event.detail.value && this.isEven(event.detail.value.length)) {
            this.setHighlightedDates(event.detail.value);

            const [from, to] = this.orderDates(this.datetime);
            const isoFrom = new Date(from);
            const isoTo = new Date(to);

            isoFrom.setHours(0, 0, 0);
            isoTo.setHours(23, 59, 59);

            this.change.emit({
                from: isoFrom.toISOString(),
                to: isoTo.toISOString(),
            });

            this.firstDateSelected = false;
        }

        if (event.detail.value && !this.isEven(event.detail.value.length)) {
            // if the customer select a date for the first time
            // do the request for the single date
            // after that continue with the above logic
            if (!this.firstDateSelected) {
                this.firstDateSelected = true;

                // if there are 2 records in the stage and 1 in the event
                // we are filter them and update the event with the correct one
                if (event.detail.value.length === 1 && this.lastStage?.length === 2) {
                    event.detail.value = this.lastStage.filter(
                        (date) => !event.detail.value.includes(date)
                    );
                }

                const isoFrom = new Date(event.detail.value.at(-1));
                const isoTo = new Date(event.detail.value.at(-1));

                isoFrom.setHours(0, 0, 0);
                isoTo.setHours(23, 59, 59);

                this.change.emit({
                    from: isoFrom.toISOString(),
                    to: isoTo.toISOString(),
                });
            }
            this.highlightedDates = [];
            this.datetime = event.detail.value.at(-1);
        }

        this.lastStage = Array.isArray(event.detail.value)
            ? event.detail.value
            : [event.detail.value];
    }

    private isEven(num: number): boolean {
        return num % 2 === 0;
    }

    private setHighlightedDates(dateStrings: string[] | string): void {
        const dateArray = Array.isArray(dateStrings) ? dateStrings : [dateStrings];

        const [start, end] = this.orderDates(dateArray);
        const dates = [];
        const current = new Date(start);

        while (current <= end) {
            dates.push({
                date: current.toISOString().split("T")[0],
                textColor: "var(--ion-color-primary)",
                backgroundColor: "rgb(var(--ion-color-primary-rgb), 0.18)",
            });
            current.setDate(current.getDate() + 1);
        }

        this.highlightedDates = dates;
    }

    private orderDates(dateArray): [Date, Date] {
        const [d1, d2] = dateArray.map((d) => new Date(d));

        const start = d1 < d2 ? d1 : d2;
        const end = d1 < d2 ? d2 : d1;

        return [start, end];
    }

    private setLocale(): void {
        const userLang = this.store.selectSnapshot(AppState.getLang);

        switch (userLang) {
            case "gb":
                this.locale = "en-US";
                break;
            case "da":
                this.locale = "da-DK";
                break;
            default:
                this.locale = "da-DK";
                break;
        }
    }
}
